import { useState } from "react";
// MUI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

export function RequestFilterBar({
  status,
  requestFilter,
  setRequestFilter,
  setColumnVisibilityModel,
}) {
  const [currentSearchValue, setCurrentSearchValue] = useState(
    requestFilter.search || "",
  );

  const handleSearchChange = (newValue) => {
    setCurrentSearchValue(newValue.target.value);
  };

  const handleSearchSumbit = (e) => {
    e.preventDefault();
    setRequestFilter((prevState) => ({
      ...prevState,
      search: currentSearchValue,
    }));
  };

  const handleSearchClear = () => {
    setCurrentSearchValue("");
    setRequestFilter((prevState) => ({
      ...prevState,
      search: "",
    }));
  };

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 2, md: 1 }}>
      <Box component="form" onSubmit={handleSearchSumbit} sx={{ flexGrow: 1 }}>
        <TextField
          onChange={handleSearchChange}
          value={currentSearchValue}
          label="Search.."
          id="request-table-search"
          name="Search"
          variant="outlined"
          size="small"
          fullWidth
          slotProps={{
            input: {
              endAdornment: (
                <>
                  <InputAdornment
                    position="end"
                    sx={{
                      visibility: currentSearchValue ? "visible" : "hidden",
                    }}
                  >
                    <IconButton onClick={handleSearchClear} color="error">
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                  <InputAdornment position="end">
                    <IconButton type="submit">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              ),
            },
          }}
        />
      </Box>
    </Stack>
  );
}
